import { createContext, useState, useMemo } from 'react';
import type { TPageInfoContext, TCustomPageInfo } from './types';

const Context = createContext<TPageInfoContext>({ pageInfo: {} });

const Provider = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  const [customPageInfo, updateCustonPageInfo] = useState<TCustomPageInfo>({
    smartInsightsDisabled: false,
    metaInformation: {},
  });
  const value = useMemo(
    () => ({
      pageInfo: {
        metaInformation: {
          ...customPageInfo.metaInformation,
          smartInsightsDisabled: customPageInfo.smartInsightsDisabled,
        },
        context: customPageInfo.context,
      },
      updatePageInfo: updateCustonPageInfo,
    }),
    [customPageInfo]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default Provider;

export { Context };
